// // import React, { useState, useEffect } from "react";
// // import { Modal, Form, Input, Checkbox, Button } from "antd";

// // const BranchForm = ({ companyId, branch, onSubmit, onCancel, loading }) => {
// //   const [form] = Form.useForm();

// //   useEffect(() => {
// //     if (branch) {
// //       form.setFieldsValue({
// //         branch_name: branch.branch_name || "",
// //         city: branch.city || "",
// //         address: branch.address || "",
// //         phone: branch.phone || "",
// //         pincode: branch.pincode || "",
// //         working_hours: branch.working_hours || "",
// //         is_head_office: branch.is_head_office || false,
// //         coverd_area: branch.coverd_area || "",
// //       });
// //     } else {
// //       form.resetFields();
// //     }
// //   }, [branch, form]);

// //   const handleSubmit = (values) => {
// //     onSubmit(values);
// //   };

// //   return (
// //     <Modal
// //       title={branch ? "Edit Branch" : "Add Branch"}
// //       open={true}
// //       onCancel={onCancel}
// //       footer={null}
// //       destroyOnClose
// //     >
// //       <Form form={form} onFinish={handleSubmit} layout="vertical">
// //         <Form.Item
// //           name="branch_name"
// //           label="Branch Name"
// //           rules={[{ required: true, message: "Branch name is required" }]}
// //         >
// //           <Input />
// //         </Form.Item>
// //         <Form.Item
// //           name="city"
// //           label="City"
// //           rules={[{ required: true, message: "City is required" }]}
// //         >
// //           <Input />
// //         </Form.Item>
// //         <Form.Item
// //           name="address"
// //           label="Address"
// //           rules={[{ required: true, message: "Address is required" }]}
// //         >
// //           <Input.TextArea rows={2} />
// //         </Form.Item>
// //         <Form.Item
// //           name="phone"
// //           label="Phone"
// //           rules={[{ required: true, message: "Phone is required" }]}
// //         >
// //           <Input type="tel" />
// //         </Form.Item>
// //         <Form.Item
// //           name="pincode"
// //           label="Pincode"
// //           rules={[{ required: true, message: "Pincode is required" }]}
// //         >
// //           <Input />
// //         </Form.Item>
// //         <Form.Item name="working_hours" label="Working Hours">
// //           <Input placeholder="e.g. 9 AM - 6 PM" />
// //         </Form.Item>
// //         <Form.Item name="coverd_area" label="Covered Area">
// //           <Input placeholder="Area1, Area2, Area3" />
// //         </Form.Item>
// //         <Form.Item name="is_head_office" valuePropName="checked">
// //           <Checkbox>Head Office</Checkbox>
// //         </Form.Item>
// //         <Form.Item>
// //           <div style={{ textAlign: "end" }}>
// //             <Button style={{ marginRight: 8 }} onClick={onCancel}>
// //               Cancel
// //             </Button>
// //             <Button type="primary" htmlType="submit" loading={loading}>
// //               {loading ? "Saving..." : branch ? "Update Branch" : "Add Branch"}
// //             </Button>
// //           </div>
// //         </Form.Item>
// //       </Form>
// //     </Modal>
// //   );
// // };

// // export default BranchForm;

// import React, { useState, useEffect } from "react";
// import { Modal } from "antd";

// const BranchFormModal = ({
//   showBranchForm,
//   setShowBranchForm,
//   selectedCompany,
//   branch,
//   setEditingBranch,
//   handleBranchSubmit,
//   loading,
// }) => {
//   const [formData, setFormData] = useState({
//     branch_name: "",
//     city: "",
//     address: "",
//     phone: "",
//     pincode: "",
//     working_hours: "",
//     is_head_office: false,
//     coverd_area: "",
//   });

//   // prefill when editing
//   useEffect(() => {
//     if (branch) {
//       setFormData(branch);
//     } else {
//       setFormData({
//         branch_name: "",
//         city: "",
//         address: "",
//         phone: "",
//         pincode: "",
//         working_hours: "",
//         is_head_office: false,
//         coverd_area: "",
//       });
//     }
//   }, [branch]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleBranchSubmit(formData, selectedCompany?.id);
//   };

//   const handleCancel = () => {
//     setShowBranchForm(false);
//     setEditingBranch(null);
//     setFormData({
//       branch_name: "",
//       city: "",
//       address: "",
//       phone: "",
//       pincode: "",
//       working_hours: "",
//       is_head_office: false,
//       coverd_area: "",
//     });
//   };

//   return (
//     <Modal
//       title={branch ? "Edit Branch" : "Add Branch"}
//       open={showBranchForm}
//       onCancel={handleCancel}
//       footer={null}
//       width={700}
//       className="bootstrap-modal"
//       afterClose={() => {
//         setFormData({
//           branch_name: "",
//           city: "",
//           address: "",
//           phone: "",
//           pincode: "",
//           working_hours: "",
//           is_head_office: false,
//           coverd_area: "",
//         });
//       }}
//     >
//       <div className="col-12">
//         <div className="card" style={{ border: "none", boxShadow: "none" }}>
//           <form onSubmit={handleSubmit}>
//             <div className="card-body" style={{ padding: "0" }}></div>

//             <div className="card-body">
//               <div className="row">
//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="branch_name" className="form-label">
//                       Branch Name
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="branch_name"
//                       name="branch_name"
//                       value={formData.branch_name}
//                       onChange={handleInputChange}
//                       placeholder="Enter Branch Name"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="city" className="form-label">
//                       City
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="city"
//                       name="city"
//                       value={formData.city}
//                       onChange={handleInputChange}
//                       placeholder="Enter City"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="col-12">
//                   <div className="mb-3">
//                     <label htmlFor="address" className="form-label">
//                       Address
//                     </label>
//                     <textarea
//                       className="form-control"
//                       id="address"
//                       name="address"
//                       value={formData.address}
//                       onChange={handleInputChange}
//                       rows="2"
//                       placeholder="Complete Address"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="phone" className="form-label">
//                       Phone
//                     </label>
//                     <input
//                       type="tel"
//                       className="form-control"
//                       id="phone"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder="Phone Number"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="pincode" className="form-label">
//                       Pincode
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="pincode"
//                       name="pincode"
//                       value={formData.pincode}
//                       onChange={handleInputChange}
//                       placeholder="Pincode"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="working_hours" className="form-label">
//                       Working Hours
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="working_hours"
//                       name="working_hours"
//                       value={formData.working_hours}
//                       onChange={handleInputChange}
//                       placeholder="e.g. 9 AM - 6 PM"
//                     />
//                   </div>
//                 </div>

//                 <div className="col-md-6">
//                   <div className="mb-3">
//                     <label htmlFor="coverd_area" className="form-label">
//                       Covered Area
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="coverd_area"
//                       name="coverd_area"
//                       value={formData.coverd_area}
//                       onChange={handleInputChange}
//                       placeholder="Area1, Area2, Area3"
//                     />
//                   </div>
//                 </div>

//                 <div className="col-12">
//                   <div className="form-check mb-3">
//                     <input
//                       type="checkbox"
//                       className="form-check-input"
//                       id="is_head_office"
//                       name="is_head_office"
//                       checked={formData.is_head_office}
//                       onChange={handleInputChange}
//                     />
//                     <label
//                       className="form-check-label"
//                       htmlFor="is_head_office"
//                     >
//                       Head Office
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="d-flex justify-content-end">
//               <div className="d-flex gap-3">
//                 <button
//                   type="button"
//                   className="btn bg-danger-subtle text-danger px-4"
//                   onClick={handleCancel}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={loading}
//                 >
//                   {loading
//                     ? "Saving..."
//                     : branch
//                     ? "Update Branch"
//                     : "Save Branch"}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default BranchFormModal;


import React, { useState, useEffect } from "react";
import "../../App.css";

const BranchFormModal = ({
  showBranchForm,
  setShowBranchForm,
  selectedCompany,
  branch,
  setEditingBranch,
  handleBranchSubmit,
  loading,
}) => {
  const [formData, setFormData] = useState({
    branch_name: "",
    city: "",
    address: "",
    phone: "",
    pincode: "",
    working_hours: "",
    is_head_office: false,
    coverd_area: "",
  });

  useEffect(() => {
    if (branch) {
      setFormData(branch);
    } else {
      resetForm();
    }
  }, [branch]);

  const resetForm = () => {
    setFormData({
      branch_name: "",
      city: "",
      address: "",
      phone: "",
      pincode: "",
      working_hours: "",
      is_head_office: false,
      coverd_area: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleBranchSubmit(formData, selectedCompany?.id);
  };

  const handleCancel = () => {
    setShowBranchForm(false);
    setEditingBranch(null);
    resetForm();
  };

  return (
    <div
      className={`modal fade ${showBranchForm ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {branch ? "Edit Branch" : "Add Branch"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCancel}
            ></button>
          </div>

          <div className="modal-body modal-body-scroll">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Branch Name */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="branch_name" className="form-label">
                    Branch Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="branch_name"
                    name="branch_name"
                    value={formData.branch_name}
                    onChange={handleInputChange}
                    placeholder="Enter Branch Name"
                    required
                  />
                </div>

                {/* City */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="Enter City"
                    required
                  />
                </div>

                {/* Address */}
                <div className="col-12 mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <textarea
                    className="form-control"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows="2"
                    placeholder="Complete Address"
                    required
                  />
                </div>

                {/* Phone */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone" className="form-label">
                    Phone
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number"
                    required
                  />
                </div>

                {/* Pincode */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="pincode" className="form-label">
                    Pincode
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pincode"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                    placeholder="Pincode"
                    required
                  />
                </div>

                {/* Working Hours */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="working_hours" className="form-label">
                    Working Hours
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="working_hours"
                    name="working_hours"
                    value={formData.working_hours}
                    onChange={handleInputChange}
                    placeholder="e.g. 9 AM - 6 PM"
                  />
                </div>

                {/* Covered Area */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="coverd_area" className="form-label">
                    Covered Area
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="coverd_area"
                    name="coverd_area"
                    value={formData.coverd_area}
                    onChange={handleInputChange}
                    placeholder="Area1, Area2, Area3"
                  />
                </div>

                {/* Head Office */}
                <div className="col-12 mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="is_head_office"
                      name="is_head_office"
                      checked={formData.is_head_office}
                      onChange={handleInputChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="is_head_office"
                    >
                      Head Office
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="modal-footer d-flex justify-content-end gap-3 p-3 mt-3">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger px-4"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : branch ? "Update Branch" : "Save Branch"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchFormModal;
